const LAUNCHPADUSERS_SORT_TYPES = {
  ASCENDING: 0,
  DESCENDING: 1,
};

const LAUNCHPADUSERS_SORT_KEYS = {
  FULL_NAME: 0,
  EMAIL: 1,
  KYC_STATUS: 2,
  TWO_FACTOR_STATUS: 3,
  LAST_ACTIVE: 4,
  STATUS: 5,
};

const getLaunchpadKycSortValue = (launchpadUser) => {
  const kycStatus = Array.isArray(launchpadUser?.kyc) ? launchpadUser.kyc[0]?.kyc_status : null;

  if (!kycStatus || kycStatus === 'false' || kycStatus === 'Cancelled') {
    return 0;
  }

  if (kycStatus === 'Approved') {
    return 2;
  }

  return 1;
};

const getLaunchpadStatusSortValue = (launchpadUser) =>
  launchpadUser?.is_active?.toString().toLowerCase() === 'true' ? 1 : 0;

const sortTypes = [
  {
    name: 'Ascending',
    icon: 'BiSortUp',
  },
  {
    name: 'Descending',
    icon: 'BiSortDown',
  },
];

const sortKeys = [
  {
    name: 'Full Name',
    key: 'full_name',
    type: 'string',
    defaultSortType: LAUNCHPADUSERS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'Email',
    key: 'email',
    type: 'string',
    defaultSortType: LAUNCHPADUSERS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'KYC Status',
    type: 'number',
    getValue: getLaunchpadKycSortValue,
    defaultSortType: LAUNCHPADUSERS_SORT_TYPES.DESCENDING,
  },
  {
    name: '2FA Status',
    key: 'two_factor_auth',
    type: 'boolean',
    defaultSortType: LAUNCHPADUSERS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Last Active',
    key: 'last_active_at',
    type: 'date',
    defaultSortType: LAUNCHPADUSERS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Status',
    type: 'number',
    getValue: getLaunchpadStatusSortValue,
    defaultSortType: LAUNCHPADUSERS_SORT_TYPES.DESCENDING,
  },
];

const launchpadUsersQuickFilterConstants = {
  ALL: 1,
  TRUE: 2,
  FALSE: 3,
};

export {
  LAUNCHPADUSERS_SORT_KEYS,
  LAUNCHPADUSERS_SORT_TYPES,
  sortTypes,
  sortKeys,
  launchpadUsersQuickFilterConstants,
};
